module.exports = __webpack_public_path__ + "static/media/ui.flow.f0b3116c.gif";